module.exports = __webpack_public_path__ + "img/carpet.c8db5549.png";